<template>
   <li class="cemetery-occupation-item" :class="{'cursor-default': !enableView}">
        <div class="occupation-wrapper"
            @click.prevent="onView">
            <span class="occupation-id">{{ number }}</span>
            <template v-if="hasPersons">
                <span class="occupation-persons">
                    {{ textPersons }}
                </span>
                <span class="occupation-quantity">
                    <span class="person-icon">
                        <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                            <path d="M11.2875 4.11067C11.6569 6.33744 9.73611 8.26726 7.4459 7.97036C6.04222 7.74769 4.93405 6.63434 4.71242 5.22405C4.34303 2.99729 6.26385 1.06737 8.48019 1.36427C9.95774 1.51272 11.1398 2.70039 11.2875 4.11067Z" stroke="#181429" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M2 13.334V11.6673C2 11.4673 2.07059 11.2673 2.28235 11.134C2.91765 10.6006 4.89412 9.33398 8 9.33398C11.1059 9.33398 13.0824 10.6006 13.7176 11.134C13.8588 11.2673 14 11.4673 14 11.6673V13.334C14 13.734 13.7176 14.0007 13.2941 14.0007H2.70588C2.28235 14.0007 2 13.734 2 13.334Z" stroke="#181429" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                    <span class="quantity-number">{{ numPersons }}</span>
                </span>
            </template>
            <template v-else>
                <span class="occupation-label vacant"> {{ state }} </span>
            </template>
        </div>
        <div v-if="false" class="occupation-actions">
            <button
                class="btn btn-link btn-block text-left"
                type="button"
                :aria-label="`view ${number}`"
                @click.prevent="onOpenSector">
                <span class="button-wrapper">
                    <i class="fas fa-pencil"></i>
                    <!-- <i class="fa-solid fa-eye"></i> -->
                </span>
            </button>
            <button
                class="btn btn-link btn-block text-left"
                type="button"
                :aria-label="`view on map ${number}`"
                @click.prevent="onViewOnMap">
                <span class="button-wrapper">
                    <i class="fas fa-location-dot"></i>
                </span>
            </button>
        </div>
   </li>
</template>

<script>
    import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
    import { EVENTS } from '../../../shared/config/event-constants';

    export default {
        mixins: [
            CemeteryElementMixin
        ],
        props: {
            cemeteryCode: {
                type: [Number, String],
                default: null,
            },
            enableView: {
                type: Boolean,
                default: false,
            },
            enableViewOnMap: {
                type: Boolean,
                default: true,
            },
            eventOccupationShow: {
                type: String,
                default: EVENTS.SHOW_MODAL_READ_OCCUPATION,
            },
            eventSectorsShow: {
                type: String,
                default: EVENTS.SHOW_MODAL_SECTORS,
            },
        },
        data() {
            return {
            }
        },
        computed: {
            modelTranslateID() {
                return `${this.baseTranslateID}.model.occupations`
            },
            id() {
                return this.value?.id ?? '';
            },
            name() {
                return this.value?.name ?? '';
            },
            number() {
                return this.value?.number ?? '';
            },
            state() {
                return 'Livre';
            },
            entities() {
                return this.value?.entities ?? [];
            },
            numPersons() {
                return this.entities.length;
            },
            hasPersons() {
                return this.numPersons > 0;
            },
            textPersons() {
                return this.entities.map(e => this.numPersons>1 ? this.initials(e.name) : e.name).join(', ');
            },
            feature() {
                let{...feature} = this.value
                return feature;
            },
        },
        methods: {
            initials(fullName) {
                // Create a array from fullName
                let arrName = fullName.split(" ");
                // Select the first name
                let iniName = arrName[0];
                // Select the first letter of the lastname
                let lastName = arrName.length>1 ? (' ' + arrName[arrName.length - 1].charAt(0) + '.') : '';

                // Return the initials
                return iniName + lastName;
            },
            onView() {
                if(this.enableView && this.eventOccupationShow) {
                    let _data = {...this.value};
                    this.$eventBus.publish(
                        this.moduleCode,
                        this.eventOccupationShow,
                        {
                            data: _data,
                            zoom: true,
                            callback: this.eventSectorsShow && this.cemeteryCode ? (params = {}) => {
                                this.$eventBus.publish(
                                    this.moduleCode,
                                    this.eventSectorsShow,
                                    {
                                        data: {cemetery: {code: this.cemeteryCode}},
                                        ...params
                                    }
                                );
                            } : null
                        }
                    );
                    this.$emit('view', _data);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.cemetery-occupation-item {
    padding-top: 8px;
    padding-bottom: 8px;
    list-style: none;
    padding-left: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(24, 20, 41, 0.1);
    cursor: pointer;

    .occupation-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .occupation-id {
            font-size: 15px;
            min-width: 80px;
            max-width: 80px;
            display: block;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.7);
            // font-family: var(--city-medium-font-family);
        }

        .occupation-label {
            padding: 2px 4px;
            height: 16px;
            box-sizing: border-box;
            border-radius: 4px;
            font-weight: bold;
            font-size: 10px;
            line-height: 17px;
            margin-left: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;

            .vacant {
                color: #27ae60;
                background: rgba(39, 174, 96, 0.2);
            }

            .reserved {
                color: #f2c94c;
                background: rgba(242, 201, 76, 0.2);
            }

            .sale {
                color: #27ae60;
                background: rgba(39, 174, 96, 0.2);
            }
        }

        .occupation-quantity {
            display: flex;
            align-items: center;
            padding-left: 4px;
            padding-right: 4px;
            box-sizing: border-box;
            opacity: 0.6;

            .person-icon {
                width: 16px;
                height: 16px;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                fill: currentColor;
                background-repeat: no-repeat;
            }

            .quantity-number {
                margin-left: 4px;
                font-size: 14px;
                line-height: 14px;
            }
        }

        .occupation-persons {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            margin-left: 5px;
        }
    }

    .occupation-actions {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            color: RGB(from var(--primary-color) r g b / .7);
            min-width: 0;
            padding-left: 7px;
            padding-right: 7px;
            font-size: .85rem;

            &:last-child {
                padding-right: 0;
            }

            &:hover,
            &:active,
            &:focus {
                text-decoration: none;
                box-shadow: none;
            }
        }
    }
}
</style>